/* eslint-disable import/no-cycle */
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getAuthToken } from 'utils/cookies';
import store from 'containers/store';
import * as actions from 'containers/App/actions';

const customFetch = (uri, options) => {
  return fetch(uri, options)
    .then(response => {
      // Check if response is a redirect.
      if (response.redirected) {
        // Follow the redirect.
        if (store) {
          store.dispatch(actions.pushAuthError(response.url));
        }
      }
      return response;
    });
};

const authToken = getAuthToken();
const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URL,
  credentials: 'include',
  fetch: customFetch,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: authToken ? `Bearer ${authToken}` : '1',
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
});
